import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'components';
import BreadCrumbItem from './BreadCrumbItem/index';

import './breadcrumbs.scss';

export class BreadCrumbs extends Component {
  static propTypes = {
    addClassBreadcrumbs: PropTypes.string,
    items: PropTypes.array,
    separator: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    addArrowLeft: PropTypes.bool,
    color: PropTypes.string,
  };

  static defaultProps = {
    separator: '/',
    addArrowLeft: false,
  };
  render() {
    const { items, separator, addClassBreadcrumbs, color, addArrowLeft } =
      this.props;

    return (
      <div className={`breadcrumbs ${addClassBreadcrumbs}`}>
        {addArrowLeft && (
          <Link
            to={items[0]?.url}
            className="breadcrumb-item"
            style={{ height: '20px' }}
          >
            <ArrowLeftIcon />
          </Link>
        )}
        {items.map((item, index) => (
          <Fragment key={`${item.title}-${index}`}>
            <BreadCrumbItem item={item} color={color} />
            <div className="color-persian-red">
              {items.length - 1 !== index && separator}
            </div>
          </Fragment>
        ))}
      </div>
    );
  }
}
